const $ = require('jquery');

// auto select first item in hotels dropdown in booking-bar if only one option (and not yet checked)
$('.booking-form-fields .field-popup--hotel').each(function () {
    if ($('input[type="radio"]', this).length === 1 && $('input[type="radio"]:checked', this).length < 1) {
        $('input[type="radio"]:not(:checked)', this).first().prop('checked', true).trigger('change');
    }
});

$('.booking-form-fields').each(function () {
    let $fields = $(this);

    if ($('input[name="hotel"]:checked', this).length < 1) {
        $('button[type="submit"]', this).prop('disabled', true);

        $('input[name="hotel"]', this).on('change', function () {
            $fields.find('button[type="submit"]').prop('disabled', false);
        });
    }

    $('.form-submit', this).on('click', function (e) {
        e.stopImmediatePropagation();

        if ($('button:disabled', this).length > 0) {
            $fields.find('.field-hotel .toggle-field-popup').trigger('click');
        }
    });
});